"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _utils = require("./utils");

var OBJECT_POSITION_REGEX = /-?\d+(\.\d+)?(px|in|mm|cm|pt|%|vw|vh|px)?/g;
var matchObjectPosition = R.match(OBJECT_POSITION_REGEX);

var processObjectPosition = function processObjectPosition(key, value) {
  var match = matchObjectPosition(value);
  return {
    objectPositionX: (0, _utils.castFloat)((match === null || match === void 0 ? void 0 : match[0]) || value),
    objectPositionY: (0, _utils.castFloat)((match === null || match === void 0 ? void 0 : match[1]) || value)
  };
};

var _default = processObjectPosition;
exports.default = _default;